import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const PlacementWrapper = styled.div`
  bottom: 12px;
  position: absolute;
  display: none;

  @media ${breakpoints.small} {
    display: block;
  }
`;

export const ButtonOutline = styled.div`
  align-items: center;
  border-radius: 50%;
  border: 1px solid #ffffff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 31px;
  justify-content: center;
  width: 31px;
`;

export const Text = styled.div`
  color: #ffffff;
  font-family: 'Open Sans', sans-serif;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.18px;
  line-height: 27px;
  text-align: center;
`;
